// If there's a set of tabs, activate the first one - i.e. opening it.
// As the built-in plugin doesn't bother doing so. Lol
let tabs = document.querySelectorAll(".content-tab-addition:first-child");
if (tabs) {
  tabs.forEach(t => {
    t.classList.add("active");
  });
}
